import styled from "styled-components";

interface IToggleButton {
  $active: boolean;
}

export const Wrapper = styled.div`
  display: flex;
  padding: 24px 0;
  gap: 16px;
  position: relative;

  .css-2b097c-container {
    margin-right: auto;
    display: none;
    .css-1pahdxg-control {
      min-width: ${200 / 16}rem;
    }
    .css-yk16xz-control {
      border: 1.5px solid hsla(219, 62%, 92%, 1);
      border-radius: 8px;
      justify-content: center;
      min-width: ${200 / 16}rem;
      .css-1wa3eu0-placeholder {
        color: ${({ theme }) => theme.palette.primary.blue900};
        font-family: "Inter", sans-serif;
        opacity: 0.5;
        font-size: ${14 / 16}rem;
        font-weight: 500;
      }

      .css-1okebmr-indicatorSeparator {
        display: none;
      }
      .css-tlfecz-indicatorContainer {
        cursor: pointer;
        svg {
          border-radius: 50%;
          background-color: ${({ theme }) => theme.palette.primary.blue50};
        }
      }
    }
  }

  button:first-of-type {
    margin-right: auto;

    max-width: ${100 / 16}rem;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    button:first-of-type {
      display: none;
    }
    .css-2b097c-container {
      display: flex;
    }
  }
`;

export const ToggleButton = styled.button<IToggleButton>`
  display: flex;
  align-items: center;
  padding: 8px;
  border: 1.5px solid
    ${({ $active, theme }) =>
      $active ? theme.palette.primary.blue500 : theme.palette.primary.blue50};
  border-radius: 8px;
  background-color: white;

  svg {
    width: ${24 / 16}rem;
    height: ${24 / 16}rem;
    color: ${({ $active, theme }) =>
      $active ? theme.palette.primary.blue500 : theme.palette.primary.blue900};
  }
`;

export const FiltersNumberIndicator = styled.div`
  width: 24px;
  height: 24px;
  display: flex;
  padding: 4px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  position: absolute;
  left: 72px;
  top: 12px;
  color: #fff;
  font-family: sans-serif;
  background-color: ${({ theme }) => theme.palette.secondary.orange500};
  font-size: ${14 / 16}rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: none;
  }
`;
